export default __webpack_public_path__ + "static/media/springboot.0567238b.png";